export const COMM_OK			= 0
export const COMM_ERR_TO		= -1
export const COMM_ERR_NOT_OPEN		= -2

/**
 * 
 * @param {*} url 
 * @param {*} params 
 * 
 * Possible Param Values:
 * 
 * params.autoReconnect                 (Default: true)  This will try to reconnect when the server closes connection
 * params.autoReconnectInterval         (Default: 1000)  This will try the reconnect every second
 * params.autoReconnectMaxRetries       (Default: 600)   This will try to reconnect for up to 10 minutes
 * params.requestTimeout                (Default: 3000) This will resend a request after 30 seconds
 * params.requestRetryInterval          (Default: 5000)  This will scan the retry queue every 5 seconds for any timed out requests
 * params.requestRetryQueueMaxLength    (Default: 1000)  This will only allow the retry queue to grow to 1000 items in length
 */
function WsR2(url, params) {
	const minConnDelay = 500 + Math.random() * 500;
	let ws = null;
	let requestIDs = {};
	let sequence = 0;
	let initialConnectionEstablished = false;
	let onOpenCallback = null;
	let onMessageCallback = null;
	let onCloseCallback = null;
	let onReOpenCallback = null;
	let onErrorCallback = null;
	let onProtoErrorCallback = null;
	let connectLock = false;
	let retryCount = -1;
	let openTimeout = 0;
	
	//Setup public event listener methods
	this.onopen = (callback) => {
		onOpenCallback = callback;
	};

	this.onmessage = (callback) => {
		onMessageCallback = callback;
	};

	this.onclose = (callback) => {
		onCloseCallback = callback;
	};

	this.onreopen = (callback) => {
		onReOpenCallback = callback;
	};

	this.onerror = (callback) => {
		onErrorCallback = callback;
	}

	this.onprotoerror = (callback) => {
		onProtoErrorCallback = callback;
	}

	// Helper functions
	function isNumeric(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	}

// 	function getDateStr() {
// 		let t = new Date();
// 
// 		return t.getDate() + '.' + (t.getMonth() + 1) + '. ' + t.getHours() + ':' + ("0" + t.getMinutes()).slice(-2) + ':' + ("0" + t.getSeconds()).slice(-2);
// 	}

	this.close = () => {
		console.log('WsR2.close, ws.state', ws ? ws.readyState : 'null');
		if (ws && ws.readyState === WebSocket.OPEN) {
			ws.close();
		}
	};

	// Setup public action methods
	this.send = (data, callback, priv = null) => {
		if (!ws || ws.readyState !== WebSocket.OPEN) {
			console.error('WsR2.send: send attempt to', ws ? 'not open' : 'null', 'ws!');

			if (callback) {
				callback(COMM_ERR_NOT_OPEN);
			}

			return;
		}

		if (callback) {
			data.req_id = sequence;

			//Save off the callback function
			requestIDs[sequence] = {callback: callback, timestamp: new Date().getTime(), priv: priv};

			//Make sure we don't exceed that max int in javascript
			if (sequence < Number.MAX_SAFE_INTEGER) { 
				sequence++; 
			} else { 
				sequence = 0; 
			}
		}

//		console.log('WS', data);

		ws.send(JSON.stringify(data));
	};

	// Event handlers
	const processOnOpen = () => {
// 		console.log('processOnOpen', getDateStr());
		openTimeout = setTimeout(() => resetRetry(), 5000);

		if (!initialConnectionEstablished) {
			if (onOpenCallback) {
				onOpenCallback();
			}

			initialConnectionEstablished = true;
		} else {
			if (onReOpenCallback) {
				onReOpenCallback();
			}
		}
	}

	function processOnMessage(e) {
		try {
			let json = JSON.parse(e.data);

//			console.log('processsOnMessage', json);

			try {
				if (json.req_id !== undefined && json.req_id !== null) {
					if (isNumeric(json.req_id)) {
						let req_id = json.req_id;

						delete json.req_id;

						if (requestIDs[req_id]) {
							requestIDs[req_id].callback(COMM_OK, json, requestIDs[req_id].priv);
							delete requestIDs[req_id];
						} else {
							console.error('WSR2: processMessage, req_id', req_id, 'not found! It is probably removed by timeout handler.');
						}
					} else {
						console.error("REQ-ID from server is not a number. ", json);
					}
				} else {
					if (onMessageCallback) {
						onMessageCallback(COMM_OK, json); 
					}
				}

				if (json.result === "error" && onProtoErrorCallback) {
					onProtoErrorCallback(json);
				}
			} catch(ex) {
				console.error(ex);
			}
		} catch(ex) {
			console.warn("Response from server is not JSON.");

			if (onMessageCallback) {
				onMessageCallback(COMM_OK, e.data); 
			}
		}
	}

	function processOnClose() {
// 		console.log('processOnClose', getDateStr());
		clearTimeout(openTimeout);

		connect(true);

		if (onCloseCallback) {
			onCloseCallback();
		}
	}

	function processOnError() {
// 		console.log('processOnError', getDateStr());
		clearTimeout(openTimeout);

		if (onErrorCallback) {
			onErrorCallback();
		}

		connect(true);
	}

	function nextDelay() {
		let delay;

		delay = 0;

		if (retryCount > 0) {
			delay = minConnDelay * Math.pow(1.2, retryCount - 1);
			if (delay > 3000) {
				delay = 3000;
			}
		}

// 		console.log('nextDelay', delay);

		return delay;
    	}

	function resetRetry() {
// 	       	console.log('resetRetry', getDateStr());
        	retryCount = 0;
	}

	function connect(reconn) {
// 		console.log('connect:', getDateStr(), 'lock:', connectLock, 'retryCount', retryCount, 'readyState:', ws && ws.readyState ? ws.readyState : '--');

		if (connectLock || (ws && ws.readyState === WebSocket.OPEN))
			return;

		connectLock = true;

		if (ws)
			ws.close();

		retryCount++;

		const myPromise = new Promise((resolve) => {
  			setTimeout(resolve, nextDelay());
		});

		myPromise.then(() => {
// 			console.log('attempting connection to', url, 'readyState:', ws && ws.readyState ? ws.readyState : '--');

			ws = new WebSocket(url, "obs");

			ws.onopen = processOnOpen;
			ws.onmessage = processOnMessage;
			ws.onclose = processOnClose;
			ws.onerror = processOnError;

			connectLock = false;
		});
	}

	function checkForRetries() {
//  		console.log('checkForRetries', retryQueue.length);
		if (ws) {
			for (const [key, value] of Object.entries(requestIDs)) {
				let now = new Date().getTime();

				if (now - value.timestamp >= 3000) {
					console.error('Timeout at req_id:', key);
					value.callback(COMM_ERR_TO, key);
					delete requestIDs[key];
				}
			}
		} else {
// 			console.error('NULL ws => clear reqIDs');

			for (const [key] of Object.entries(requestIDs)) {
				console.err('  del reqID', key);
				delete requestIDs[key];
			}
		}

		setTimeout(() => {checkForRetries();}, 1000);
	}

	document.addEventListener("visibilitychange", function() {
// 		console.log('visibilitychange', document.visibilityState);
		if (document.visibilityState === 'visible') {
			connect(true);
		}
	});

	connect(false);
	checkForRetries();
}

export default WsR2;
